export default __webpack_public_path__ + "static/media/Digevo.84da3daa.svg";